'use client';

import { NavbarServer } from '@/components/pi/navbar/server';
import dynamic from 'next/dynamic';

export type NavbarProps = {
  phone?: string;
};

export function Navbar({ phone }: NavbarProps) {
  const NavbarClient = dynamic(() => import('./client'), {
    ssr: false,
    loading: () => <NavbarServer phone={phone} />,
  });

  return <NavbarClient phone={phone} />;
}
export default Navbar;
